<app-free-text-question [(answer)]="answer"
                        [disabled]="disabled"
                        [filterRegExp]="filter"></app-free-text-question>
